export default __webpack_public_path__ + "static/media/Mail.44ac9aaa.svg";